<template>
  <div class="content1">
    <div class="query_con">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <!-- <el-form-item label="申报类型">
          <el-select
            v-model="query.cardType"
            placeholder="请选择申报类型"
            style="width: 200px"
            @change="queryData"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="起止时间">
          <el-date-picker
            v-model="query.medalDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 260px"
            @change="queryData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="工号">
          <el-input
            v-model="query.receiverEmpno"
            placeholder="请输入工号"
            style="width: 150px"
            clearable
            @change="queryData"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="add" @click="queryParams">查询</el-button>
          <!-- <el-button class="add" @click="addDeclare(1)">个人申报</el-button> -->
          <el-button class="add" @click="addDeclare(2)">团体申报</el-button>
          <el-button class="add" @click="exportRecord">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table_con">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="windowHeight"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55" align="center">
        </el-table-column> -->
        <el-table-column
          type="index"
          label="序号"
          align="center"
          min-width="60"
        >
        </el-table-column>
        <el-table-column
          prop="fingertipName"
          label="公益活动标题"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="empName"
          label="活动人员"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="empNo"
          label="工号"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="hour"
          label="计算公益时长"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="hour"
          label="发放公益时长"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="point"
          label="获取积分"
          align="center"
          min-width="80"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="point"
          label="获取勋章"
          align="center"
          min-width="80"
        >
        </el-table-column> -->
        <el-table-column
          prop="point"
          label="申报类型"
          align="center"
          min-width="80"
        >
          <template>
            <span> 团队时长 </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="auditName"
          label="操作人"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="材料"
          align="center"
          min-width="80"
        >
        <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.image" :key="index">
              <img style="width: 80px;height: 80px;" :src="imgUrl + item" alt="" @click="previewBeforeImage2(item)" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="enterTime"
          label="报名活动日期"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="point"
          label="报名活动时间"
          align="center"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="实际参与日期"
          align="center"
          min-width="100"
        >
        </el-table-column> -->
        <!-- <el-table-column
          prop="signInStartTime"
          label="签到时间"
          align="center"
          min-width="80"
        >
        </el-table-column>
        <el-table-column
          prop="point"
          label="申报时间"
          align="center"
          min-width="80"
        >
        </el-table-column> -->
      </el-table>
    </div>
    <div class="pagination_con">
      <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="pageData.page"
        :page-sizes="[20, 40, 60, 80, 100]"
        :page-size="pageData.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="`团体申报`"
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
    >
      <div class="dialog_content">
        <el-form
          :model="form"
          label-width="120px"
          class="demo-form-inline"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row style="flex-wrap: wrap" type="flex" :gutter="20">
            <el-col :span="12">
              <el-form-item label="活动标题" prop="title">
                <el-select
                  v-model="form.title"
                  placeholder="请选择活动标题"
                  style="width: 100%"
                  @change="changeTitle"
                >
                  <el-option
                    v-for="item in optionsName"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="singleOrTeam == 1">
              <el-form-item label="活动人员" prop="nickname">
                <el-cascader
                  v-model="form.nickname"
                  style="width: 100%"
                  :options="treeList"
                  :props="defaultProps1"
                  clearable
                  collapse-tags
                  filterable
                  placeholder="请选择活动团队"
                ></el-cascader>
              </el-form-item>
            </el-col>

            <el-col :span="12" v-if="singleOrTeam == 1">
              <el-form-item label="参与日期" prop="medalTypeId">
                <el-date-picker
                  v-model="form.date"
                  type="date"
                  placeholder="选择参与日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="singleOrTeam == 1">
              <el-form-item label="工号" prop="medalTypeId">
                <el-input v-model="form.username" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="singleOrTeam == 1">
              <el-form-item label="签到时间" prop="medalTypeId">
                <el-time-picker
                  is-range
                  v-model="form.time"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  style="width: 100%"
                  @change="changeTime"
                >
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="singleOrTeam == 1">
              <el-form-item label="计算公益时长/h" prop="medalTypeId">
                <el-input
                  v-model="form.duration"
                  type="number"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="singleOrTeam == 2">
              <el-form-item label="活动团队" prop="team">
                <el-cascader
                  v-model="form.team"
                  style="width: 100%"
                  :options="treeList"
                  :props="defaultProps"
                  clearable
                  collapse-tags
                  filterable
                  placeholder="请选择活动团队"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="singleOrTeam == 2">
              <el-form-item label="起止时间" prop="medalTypeId">
                <el-date-picker
                  v-model="form.data1"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeStartOrStop"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12" v-if="singleOrTeam == 2">
              <el-form-item label="最大公益时长/h" prop="duration1">
                <el-input v-model="form.duration1" type="number"></el-input>
              </el-form-item>
            </el-col> -->
            <div class="line"></div>
            <el-col :span="12">
              <el-form-item label="发放公益时长/h" prop="releaseTime">
                <el-input
                  v-model="form.releaseTime"
                  type="number"
                  @change="changeReleaseTime"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="预计换算积分" prop="medalTypeId">
                <el-input v-model="form.point" disabled></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="24">
              <el-form-item label="附件材料" prop="fileId">
                <el-upload
                  :action="`${upload}/file/upload`"
                  list-type="picture-card"
                  :on-success="handleBeforeImage"
                  :on-remove="handleRemove"
                  :on-preview="previewBeforeImage"
                  :file-list="beforeImageList"
                  accept=".jpg,.jpeg,.png"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button class="add" @click="confirmSubmit" :disabled="isBtnDisabled"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import api from "@/apis/medal";
import moment from "moment";
import { getToken } from "@/utils/cookie";
export default {
  name: "group",
  data() {
    return {
      query: {
        cardType: "",
        medalDate:[]
      },
      form: {
        fileId: [],
      },
      pageData: {
        page: 1,
        pageSize: 20,
      },
      total: 0,
      tableData: [],
      tableLoading: false,
      windowHeight: 350,
      isShowRecord: 1,
      optionsType: [
        {
          label: "个人申报",
          value: 1,
        },
        {
          label: "团体申报",
          value: 2,
        },
      ],
      optionsName: [],
      dialogVisible: false,
      defaultProps1: {
        children: "child",
        value: "nickname",
        label: "nickname",
        emitPath: false,
      },
      defaultProps: {
        children: "child",
        multiple: true,
        // checkStrictly: true,
        value: "username",
        label: "nickname",
        emitPath: false,
        // expandTrigger: "hover"
      },
      treeList: [],
      upload: "",
      hideUpload: false,
      beforeImageList: [],
      dialogVisibleImg: false,
      dialogImageUrl: "",
      singleOrTeam: "",
      rules: {
        title: [
          { required: true, message: "请选择活动标题", trigger: "change" },
        ],
        nickname: [
          { required: true, message: "请选择活动人员", trigger: "change" },
        ],
        team: [
          { required: true, message: "请选择活动人员", trigger: "change" },
        ],
        fileId: [
          { required: true, message: "请选择附件材料", trigger: "change" },
        ],
        releaseTime: [
          { required: true, message: "请输入发放公益时长", trigger: "blur" },
        ],
      },
      isBtnDisabled: false,
      imgUrl: "",
      titleInfo: {},
    };
  },
  mounted() {
    this.upload = api.upload;
    this.imgUrl = api.imgUrl;
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.queryData();
    this.queryType();
    this.querydirectory();
  },
  //·组件销毁时移除事件监听器
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 300;
      });
    },
    queryParams() {
      this.queryData();
    },
    // 标题改变
    changeTitle(val) {
      this.titleInfo = this.optionsName.find((item) => item.id == val);
    },
    // 导入
    handleExport() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 选择table
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 分页
    handleSizeChange1(val) {
      this.pageData.pageSize = val;
      this.queryData();
    },
    // 当前页数
    handleCurrentChange1(val) {
      this.pageData.page = val;
      this.queryData();
    },

    // 查询 列表
    queryData() {
      const json = {
        ...this.pageData,
        empNo: this.query.receiverEmpno,
        state: "",
        typeId: 6,
        startTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        endTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[1]).format("YYYY-MM-DD HH:mm:ss")
            : "",
      };
      this.tableLoading = true;
      api
        .pubBenefitAdminPersonListListApi(json)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.tableData.forEach((item) => {
              item.signInStartTime = item.signInStartTime
                ? this.$moment(item.signInStartTime).format(
                    "YYYY-MM-DD HH:mm:ss"
                  )
                : "";
              item.signInEndTime = item.signInEndTime
                ? this.$moment(item.signInEndTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.enterTime = item.enterTime
                ? this.$moment(item.enterTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.updateTime = item.updateTime
                ? this.$moment(item.updateTime).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.image = item.image ? item.image.split(",") : [];
            });
            this.total = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 查询类型
    queryType() {
      api.queryPubBenefitApi().then((res) => {
        if (res.code == 200) {
          this.optionsName = res.data.list;
        }
      });
    },
    // 改变起止时间，计算最大公益时长ho
    changeStartOrStop(value) {
      const startTime = new Date(value[0]);
      const endTime = new Date(value[1]);
      const timeDiff = endTime - startTime;
      this.form.duration1 = (timeDiff / (1000 * 60 * 60)).toFixed(1);
      this.$forceUpdate();
    },
    //签到时间n
    changeTime(value) {
      const startTime = moment(value[0]).format("HH:mm:ss");
      const endTime = moment(value[1]).format("HH:mm:ss");
      this.form.duration = this.timeDifference(startTime, endTime);

      this.$forceUpdate();
    },
    // 时分秒 计算时长
    timeDifference(startTime, endTime) {
      // 解析时间字符串为小时、分钟、秒
      const parseTime = (time) => {
        const [hours, minutes, seconds] = time.split(":").map(Number);
        return { hours, minutes, seconds };
      };

      const start = parseTime(startTime);
      const end = parseTime(endTime);

      // 将开始时间和结束时间转换为总秒数
      const startInSeconds =
        start.hours * 3600 + start.minutes * 60 + start.seconds;
      const endInSeconds = end.hours * 3600 + end.minutes * 60 + end.seconds;
      // 计算时间差（秒）
      let diffInSeconds = endInSeconds - startInSeconds;

      // 如果结束时间小于开始时间，说明跨天，调整差值
      if (diffInSeconds < 0) {
        diffInSeconds += 24 * 3600; // 加上24小时的秒数
      }

      // 将差值转换为小时和分钟
      const diffHours = Math.floor(diffInSeconds / 3600);
      const diffMinutes = Math.floor((diffInSeconds % 3600) / 60);

      return `${diffHours}.${diffMinutes}`;
    },
    // 导出
    exportRecord() {
      const json = {
        empNo: this.query.receiverEmpno,
        state: "",
        typeId: 6,
        startTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[0]).format("YYYY-MM-DD HH:mm:ss")
            : "",
        endTime:
          this.query.medalDate?.length > 0
            ? moment(this.query.medalDate[1]).format("YYYY-MM-DD HH:mm:ss")
            : "",
      };
      api.adminGroupListExport(json).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `集团公益活动提报记录.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
    },
    // 改变 发放公益时长
    changeReleaseTime() {},
    addDeclare(value) {
      this.singleOrTeam = value;
      this.dialogVisible = true;
    },
    //取消新增编辑弹框
    handleClose() {
      this.dialogVisible = false;
      this.form = {};
      this.beforeImageList = [];
      this.$refs.ruleForm.resetFields();
    },
    // 确认新增 编辑
    confirmSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.title == "编辑") {
            this.form.id = this.multipleSelection[0].id;
          }
          this.isBtnDisabled = true;
          console.log(this.titleInfo, "this.titleInfo");
          console.log(this.form, "this.form");

          const params = {
            empNo: getToken(),
            empNos: this.form.team,
            type: 2,
            activityId: this.titleInfo.id,
            pbType: 6,
            hour: this.form.releaseTime,
            image: this.form.fileId.join(","),
            fingertipName: this.titleInfo.title,
            enterTime: moment(this.form.data1[0]).format("YYYY-MM-DD HH:mm:ss"),
            endTime: moment(this.form.data1[1]).format("YYYY-MM-DD HH:mm:ss"),
          };
          console.log(params, "params");

          api
            .pubBenefitApplyApi(params)
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  message: "申报成功",
                  type: "success",
                });
                this.isBtnDisabled = false;
                this.form = {};
                this.beforeImageList = [];
                this.$refs.ruleForm.resetFields();
                this.dialogVisible = false;
                this.queryData();
              }
            })
            .catch(() => {
              this.isBtnDisabled = false;
            });
        } else {
          return false;
        }
      });
    },
    // 查询部门列表
    querydirectory() {
      api.directory().then((data) => {
        if (data.code == 200) {
          this.treeList = data.data;
        }
      });
    },
    //上传
    handleBeforeImage(file) {
      this.hideUpload = true;
      this.form.fileId.push(file.id);
      // this.$refs.ruleForm.clearValidate("fileId");
    },
    //删除
    handleRemove(file) {
      console.log("file", file.response.id);
      // this.form.fileId = "";
      const index = this.form.fileId.findIndex(
        (item) => file.response.id == item
      );
      this.form.fileId.splice(index, 1);
      console.log(this.form.fileId);

      this.hideUpload = false;
    },
    // 图片放大预览
    previewBeforeImage(file) {
      this.dialogImageUrl = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      this.dialogVisibleImg = true;
    },
    // 图片放大预览
    previewBeforeImage2(item){
      this.dialogImageUrl = api.imgUrl + item;
      this.dialogVisibleImg = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.content1 {
  background-color: #f2fcf9;

  .query_con {
    // margin: 30px 40px 20px 40px;
    padding: 40px 0 0px 40px;
    // border: 1px solid #e5e5e5;
    border-radius: 5px;
    ::v-deep {
      .el-date-editor .el-range-separator {
        padding: 0 28px;
      }
    }
    .add {
      color: #fff;
      background-color: #23c0d8;
      border-color: #23c0d8;
    }
  }
  .operate {
    margin: 20px 40px;
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  .table_con {
    background-color: #fff;
    border: 1px solid #e2e6e5;
    padding: 40px 20px;
    margin: 0 40px;
    border-radius: 5px;
  }
  .pagination_con {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    padding-right: 40px;
  }
  .dialog-footer {
    .add {
      color: #fff;
      background-color: #23c0d8;
    }
  }
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }
}
.dialog_content {
  .line {
    width: 100%;
    height: 2px;
    background-color: #e1e1e1;
    margin-bottom: 30px;
  }
  ::v-deep {
    .el-date-editor .el-range-separator {
      width: 40px !important;
    }
  }
}
</style>
